import { render, staticRenderFns } from "./bill-send-records-dialog.vue?vue&type=template&id=6dee02a0&scoped=true"
import script from "./bill-send-records-dialog.vue?vue&type=script&lang=js"
export * from "./bill-send-records-dialog.vue?vue&type=script&lang=js"
import style0 from "./bill-send-records-dialog.vue?vue&type=style&index=0&id=6dee02a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee02a0",
  null
  
)

export default component.exports